export default {
    /**
     * Cambiamos el estado del loader
     * @param {Object} state State
     * @param {Boolean} value Estado del loader
     */
    IS_VISIBLE(state, value) {
        state.isVisible = value;
    }
};
